import React, { memo } from 'react';
import { FadeIn } from './FadeIn';
import { X, Check, Headphones, Brain, Zap, Heart } from 'lucide-react';
export function MaquinaAdministrativa() {
  const comparisons = [{
    task: 'Tiempo mínimo diario',
    without: '20-45 min',
    with: '14-18 min'
  }, {
    task: 'Primeros resultados',
    without: 'Semana 3-4',
    with: 'Día 3-7'
  }, {
    task: 'Uso en público',
    without: 'Solo en casa',
    with: 'En cualquier lugar, invisible'
  }, {
    task: 'Crisis aguda',
    without: 'Protocolo de 5 min',
    with: 'Cambio de estado en 60 seg'
  }, {
    task: 'Combinación de frecuencias',
    without: 'Una por vez',
    with: 'Stacks de 2-4 frecuencias'
  }, {
    task: 'Creencias limitantes',
    without: 'No incluye',
    with: 'Reprogramación subconsciente'
  }];
  return <section className="py-8 md:py-16 px-4 max-w-5xl mx-auto" data-id="element-225">
      <FadeIn data-id="element-226">
        <div className="text-center mb-6 md:mb-12" data-id="element-227">
          <div className="inline-flex items-center justify-center w-14 h-14 md:w-20 md:h-20 rounded-full bg-[#7c3aed]/10 mb-3 md:mb-6 border border-[#7c3aed]/20 relative" data-id="element-228">
            <div className="absolute inset-0 bg-[#7c3aed]/20 blur-xl rounded-full animate-pulse" data-id="element-229"></div>
            <Headphones className="text-[#5b21b6] relative z-10 w-7 h-7 md:w-10 md:h-10" data-id="element-230" />
          </div>
          <h2 className="text-2xl md:text-5xl font-black text-[#1f1b16] mb-2 md:mb-4 px-2" data-id="element-231">
            ¿QUÉ AGREGA EL LABORATORIO VIBRACIONAL PRO?
          </h2>
          <p className="text-sm md:text-xl text-[#6b6358] font-bold max-w-2xl mx-auto" data-id="element-232">
            El sistema que convierte 600 páginas en resultados en días, no en
            meses.
          </p>
        </div>
      </FadeIn>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-6 mb-6 md:mb-12" data-id="element-233">
        <FadeIn delay={0.2} data-id="element-234">
          <div className="bg-[#ef4444]/5 border border-[#ef4444]/20 rounded-2xl p-4 md:p-8 h-full" data-id="element-235">
            <div className="flex items-center gap-3 mb-4 md:mb-8 pb-3 md:pb-4 border-b border-[#ef4444]/10" data-id="element-236">
              <div className="bg-[#ef4444]/10 p-1.5 md:p-2 rounded-lg" data-id="element-237">
                <X className="text-[#ef4444] w-5 h-5 md:w-6 md:h-6" data-id="element-238" />
              </div>
              <h3 className="text-base md:text-xl font-black text-[#ef4444]" data-id="element-239">
                Sin Laboratorio
              </h3>
            </div>
            <div className="space-y-3 md:space-y-6" data-id="element-240">
              {comparisons.map((item, i) => <div key={i} className="flex flex-col gap-0.5 md:gap-1" data-id="element-241">
                  <span className="text-xs md:text-sm text-[#6b6358] font-bold" data-id="element-242">
                    {item.task}
                  </span>
                  <span className="text-base md:text-lg font-mono text-[#1f1b16] font-medium" data-id="element-243">
                    {item.without}
                  </span>
                </div>)}
            </div>
          </div>
        </FadeIn>

        <FadeIn delay={0.3} data-id="element-244">
          <div className="bg-[#faf7f2] border-2 border-[#7c3aed]/50 rounded-2xl p-4 md:p-8 h-full relative overflow-hidden shadow-[0_10px_30px_rgba(124,58,237,0.1)]" data-id="element-245">
            <div className="absolute top-0 right-0 w-64 h-64 bg-[#7c3aed]/10 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2" data-id="element-246"></div>

            <div className="flex items-center gap-3 mb-4 md:mb-8 pb-3 md:pb-4 border-b border-[#7c3aed]/20 relative z-10" data-id="element-247">
              <div className="bg-[#7c3aed] p-1.5 md:p-2 rounded-lg shadow-[0_0_15px_rgba(124,58,237,0.5)]" data-id="element-248">
                <Check className="text-[#0f0d09] w-5 h-5 md:w-6 md:h-6" strokeWidth={3} data-id="element-249" />
              </div>
              <h3 className="text-base md:text-xl font-black text-[#5b21b6]" data-id="element-250">
                Con Laboratorio Vibracional Pro
              </h3>
            </div>
            <div className="space-y-3 md:space-y-6 relative z-10" data-id="element-251">
              {comparisons.map((item, i) => <div key={i} className="flex flex-col gap-0.5 md:gap-1" data-id="element-252">
                  <span className="text-xs md:text-sm text-[#6b6358] font-bold" data-id="element-253">
                    {item.task}
                  </span>
                  <span className="text-sm md:text-lg font-mono font-black text-[#0f0d09] bg-[#7c3aed]/20 w-fit px-2 md:px-3 py-0.5 md:py-1 rounded-md border border-[#7c3aed]/30" data-id="element-254">
                    {item.with}
                  </span>
                </div>)}
            </div>
          </div>
        </FadeIn>
      </div>

      <FadeIn delay={0.4} data-id="element-255">
        <div className="flex flex-wrap justify-center gap-2 md:gap-6" data-id="element-256">
          <div className="flex items-center gap-1.5 md:gap-2 bg-[#faf7f2] border border-[#e7dfce] px-3 md:px-4 py-1.5 md:py-2 rounded-full text-xs md:text-sm font-bold text-[#1f1b16] shadow-sm" data-id="element-257">
            <Headphones size={14} className="text-[#7c3aed]" data-id="element-258" /> Audio
          </div>
          <div className="flex items-center gap-1.5 md:gap-2 bg-[#faf7f2] border border-[#e7dfce] px-3 md:px-4 py-1.5 md:py-2 rounded-full text-xs md:text-sm font-bold text-[#1f1b16] shadow-sm" data-id="element-259">
            <Brain size={14} className="text-[#7c3aed]" data-id="element-260" /> Mente
          </div>
          <div className="flex items-center gap-1.5 md:gap-2 bg-[#faf7f2] border border-[#e7dfce] px-3 md:px-4 py-1.5 md:py-2 rounded-full text-xs md:text-sm font-bold text-[#1f1b16] shadow-sm" data-id="element-261">
            <Zap size={14} className="text-[#7c3aed]" data-id="element-262" /> Energía
          </div>
          <div className="flex items-center gap-1.5 md:gap-2 bg-[#faf7f2] border border-[#e7dfce] px-3 md:px-4 py-1.5 md:py-2 rounded-full text-xs md:text-sm font-bold text-[#1f1b16] shadow-sm" data-id="element-263">
            <Heart size={14} className="text-[#7c3aed]" data-id="element-264" /> Cuerpo
          </div>
        </div>
        <p className="text-center text-sm md:text-base text-[#5b21b6] font-black mt-3 md:mt-6" data-id="element-265">
          Resultados en días · Invisible en cualquier contexto · Bio-hacking
          avanzado
        </p>
      </FadeIn>
    </section>;
}